import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import api from '../../../../api'
import Responsive from '../../../../assets/config/Responsive'
import CarIcon from '../../../../assets/icons/JSX/CarIcon'
import CarSmallIcon from '../../../../assets/icons/JSX/CarSmallIcon'
import TravelIcon from '../../../../assets/icons/JSX/TravelIcon'
import TravelSmallIcon from '../../../../assets/icons/JSX/TravelSmallIcon'
import Colors from '../../../../assets/styles/Colors'
import EmptySreen from '../../../../components/EmptySreen'
import Loader from '../../../../components/Loader'
import WelcomerIcon from '../../../../assets/icons/JSX/WelcomerIcon'
import WelcomerSmallIcon from '../../../../assets/icons/JSX/WelcomerSmallIcon'
import PetIcon from '../../../../assets/icons/JSX/PetIcon'
import PetSmallIcon from '../../../../assets/icons/JSX/PetSmallIcon'
//
//
const PolicyTransactions: React.FC<{ policyId: number }> = ({ policyId }) => {
  //
  const { t } = useTranslation()
  //
  const { data: userTransactions, isLoading: isUserTransactionLoading } = api.useGetUserPolicyTransactionsQuery(
    policyId,
    {
      skip: !policyId,
    },
  )
  //
  const sortedTransactions = userTransactions ? [...userTransactions.orders].reverse() : []
  //
  return isUserTransactionLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {userTransactions && userTransactions.orders && userTransactions.orders.length < 1 ? (
        <EmptySreen
          bigText={t('noTransactions')}
          smallDescription={t('noActivePolicyDescription')}
          buttonText={t('priceCalculation')}
          buttonUrl="/category"
        />
      ) : (
        <>
          <TransactionsStyle>
            <TitleSection>
              <Title></Title>
              <Title>{t('product')}</Title>
              <Title>{t('company')}</Title>
              <Title>{t('insured')}</Title>
              <Title>{t('policy')}#</Title>
              <Title>{t('date')}</Title>
              <Title>{t('paidAmount')}</Title>
              {/* <Title>{t('transactionId')}</Title> */}
              <TitleHideInMobile>{t('status')}</TitleHideInMobile>
            </TitleSection>
            {sortedTransactions?.map((item, index) => (
              <ContentStyles key={index}>
                <Title>
                  {item.insuranceType === 'Travel' ? (
                    <TravelIconStyle />
                  ) : item.insuranceType === 'Tpl' ? (
                    <CarIconStyle />
                  ) : item.insuranceType === 'Welcomer' ? (
                    <WelcomerIconStyle />
                  ) : item.insuranceType === 'Pet' ? (
                    <PetIconStyle />
                  ) : null}
                </Title>
                <Title>{item.insuranceType}</Title>
                <Title>{item.companyName}</Title>
                <Title>{item.insuredName}</Title>
                <Title>{item.policyNumber}</Title>
                <Title>{item.paidAt}</Title>
                <Title>{item.amount}</Title>
                {/* <Title>{item.transactionId}</Title> */}
                <TitleHideInMobile>
                  <StatusSpan>
                    {item.status}
                    {item.status && (
                      <StatusBall
                        style={{
                          backgroundColor:
                            item.status === 'paid'
                              ? Colors.java
                              : item.status === 'pending'
                              ? Colors.Primary
                              : Colors.primaryRed,
                        }}
                      />
                    )}
                  </StatusSpan>
                </TitleHideInMobile>
              </ContentStyles>
            ))}
            <br />
            {sortedTransactions?.map((item, index) => (
              <ContentStylesMobile key={index}>
                <div>
                  <Title>
                    {item.insuranceType === 'Travel' ? (
                      <TravelSmallIconStyle />
                    ) : item.insuranceType === 'Tpl' ? (
                      <CarSmallIconStyle />
                    ) : item.insuranceType === 'Welcomer' ? (
                      <WelcomerSmallIconStyle />
                    ) : item.insuranceType === 'Pet' ? (
                      <PetSmallIconStyle />
                    ) : null}
                    {item.insuranceType}
                  </Title>
                  <Title>
                    <StatusSpan>
                      {item.status && (
                        <StatusBall
                          style={{
                            backgroundColor:
                              item.status === 'paid'
                                ? Colors.java
                                : item.status === 'pending'
                                ? Colors.Primary
                                : Colors.primaryRed,
                          }}
                        />
                      )}
                    </StatusSpan>
                  </Title>
                </div>
                <div>
                  <Title>{t('policy')}#:</Title>
                  <Title>{item.policyNumber}</Title>
                </div>
                <div>
                  <Title>{t('date')}:</Title>
                  <Title>{item.paidAt}</Title>
                </div>
                <div>
                  <Title>{t('paidAmount')}:</Title>
                  <Title>{item.amount}</Title>
                </div>
              </ContentStylesMobile>
            ))}
          </TransactionsStyle>
        </>
      )}
    </Wrapper>
  )
}
//
//
const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const ContentStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  padding-top: 40px;
  margin-top: 40px;
  box-shadow: 160px -2px 0px ${Colors.grey};
  :nth-child(1) {
    box-shadow: none;
  }
  &:nth-child(2) {
    padding-top: 20px;
    margin-top: 0px;
    border-top: 0px;
    box-shadow: none;
  }
  div {
    text-align: left;
    :first-child {
      text-align: center;
    }
    :nth-child(8) {
      text-align: center;
    }
    :last-child {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.laptop} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
`
const TransactionsStyle = styled.div`
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  &:first-child {
    margin-bottom: 55px;
  }
  ${Responsive.mobile} {
    padding-inline: 24px;
    &:first-child {
      margin-bottom: 26px;
    }
  }
`

const Wrapper = styled.div`
  margin-top: 20px;
`
const TitleSection = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  margin-bottom: 40px;
  div {
    color: ${Colors.primaryGrey};
    text-align: left;
    :nth-child(8) {
      text-align: center;
    }
    :last-child {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    margin-bottom: 10px;
  }
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  user-select: none;
  /* background-color: red; */
  /* responsive */
  ${Responsive.laptop} {
    font-size: 12px;
  }
  ${Responsive.tablet} {
    font-size: 12px;
    padding-left: 0px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`
const TitleHideInMobile = styled(Title)`
  ${Responsive.mobile} {
    display: none;
  }
`
const TravelIconStyle = styled(TravelIcon)`
  margin-top: -15px;
`
const CarIconStyle = styled(CarIcon)`
  margin-top: -15px;
`
const WelcomerIconStyle = styled(WelcomerIcon)`
  margin-top: -15px;
`
const PetIconStyle = styled(PetIcon)`
  margin-top: -15px;
`
const TravelSmallIconStyle = styled(TravelSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const CarSmallIconStyle = styled(CarSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const WelcomerSmallIconStyle = styled(WelcomerSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const PetSmallIconStyle = styled(PetSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const StatusBall = styled.span`
  height: 7px;
  width: 7px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  margin-left: 5px;
  margin-top: 7px;
  ${Responsive.mobile} {
    margin-top: 6px;
  }
  ${Responsive.mobile} {
    margin-top: 0px;
  }
`
const StatusSpan = styled.span`
  ${Responsive.mobile} {
    margin-left: -13px;
    position: relative;
  }
`

export default PolicyTransactions
